(function () {

  const SWATCH_PARTNERS = {
    // Astra Shoulder Bag
    'astra-shoulder-bag-black':       'astra-shoulder-bag-espresso',
    'astra-shoulder-bag-espresso':    'astra-shoulder-bag-black',
    // Selene Tote
    'selene-mid-size-tote-black':     'selene-mid-size-tote-espresso',
    'selene-mid-size-tote-espresso':  'selene-mid-size-tote-black',
    // Atlas Tote
    'atlas-tote-taupe':               'atlas-tote-espresso',
    'atlas-tote-espresso':            'atlas-tote-taupe',
    // Eclipse Crossbody
    'eclipse-crossbody-espresso':     'eclipse-crossbody-taupe',
    'eclipse-crossbody-taupe':        'eclipse-crossbody-espresso',
    // Polaris Phone Sling
    'polaris-phone-sling-espresso':   'polaris-phone-sling-black',
    'polaris-phone-sling-black':      'polaris-phone-sling-espresso',
    // Nox Cardholder
    'nox-cardholder-black':           'nox-cardholder-espresso',
    'nox-cardholder-espresso':        'nox-cardholder-black',
  };

  const prefetchCache = new Map();

  // Let the browser paint/handle input before continuing heavy work
  function yieldToMain() {
    if (window.scheduler && typeof scheduler.yield === 'function') return scheduler.yield();
    return new Promise((resolve) => setTimeout(resolve, 0));
  }

  // Resolves once the current frame (e.g. the fade-out) has been painted
  function afterNextPaint() {
    return new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 0)));
  }

  function prefetch(url, priority) {
    if (prefetchCache.has(url)) return;
    prefetchCache.set(url, null); // mark in-flight
    fetch(url, priority ? { priority: priority } : undefined)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        prefetchCache.set(url, parser.parseFromString(html, 'text/html'));
      })
      .catch(() => {
        prefetchCache.delete(url);
      });
  }

  function preloadAllSwatches() {
    document.querySelectorAll('[data-swatch-ajax]').forEach((link) => {
      prefetch(link.href, 'low');
    });
  }

  // Background prefetch waits for page load + idle time so it doesn't compete
  // with the hero image (LCP). touchstart still prefetches immediately.
  function preloadAllSwatchesWhenIdle() {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
    const run = () => idle(preloadAllSwatches, { timeout: 3000 });
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function clearCacheOnExit() {
    window.addEventListener('pagehide', () => prefetchCache.clear());
    window.addEventListener('beforeunload', () => prefetchCache.clear());
  }

  function getCurrentHandle() {
    try {
      const json = document.getElementById('ProductJson');
      if (json) return JSON.parse(json.textContent).handle;
    } catch (e) {}
    const parts = window.location.pathname.split('/');
    return parts[parts.length - 1] || null;
  }

  function reinitMediaGallery(fetchedDoc) {
    const newGallery = fetchedDoc.querySelector('media-gallery');
    const currentGallery = document.querySelector('media-gallery');
    if (newGallery && currentGallery) {
      currentGallery.replaceWith(newGallery.cloneNode(true));
    }
  }

  // The zoom modal lives outside media-gallery (it moves itself to <body> on load),
  // so swap only its media list — replacing the whole <product-modal> would break
  // its connectedCallback. Without this, zoom looks up the new product's media in
  // the old product's modal and throws.
  function swapZoomModal(fetchedDoc) {
    const newContent = fetchedDoc.querySelector('product-modal .product-media-modal__content');
    const currentContent = document.querySelector('product-modal .product-media-modal__content');
    if (newContent && currentContent) {
      currentContent.replaceChildren(...newContent.childNodes);
    }
  }

  function prependPartnerCard(recsEl, partnerHandle) {
    const partnerUrl = window.location.origin + '/products/' + partnerHandle;
    const partnerDoc = prefetchCache.get(partnerUrl);
    if (!(partnerDoc instanceof Document)) return;

    const partnerRecsEl = partnerDoc.querySelector('product-recommendations');
    let partnerCardLi = null;

    if (partnerRecsEl) {
      partnerCardLi = partnerRecsEl.querySelector('ul li');
    }

    if (!partnerCardLi) {
      const anyCard = partnerDoc.querySelector('.card-product, .card--product');
      if (anyCard) {
        partnerCardLi = document.createElement('li');
        partnerCardLi.className = 'grid__item';
        partnerCardLi.appendChild(anyCard.cloneNode(true));
      }
    }

    if (!partnerCardLi) return;

    const recsList = recsEl.querySelector('ul');
    if (!recsList) return;

    const alreadyPresent = recsList.querySelector(`[href*="${partnerHandle}"]`);
    if (alreadyPresent) {
      alreadyPresent.closest('li').remove();
    }

    partnerCardLi.dataset.partnerPrepend = 'true';
    recsList.prepend(partnerCardLi);
  }

  function swapRecommendations(fetchedDoc) {
    const newRecsEl = fetchedDoc.querySelector('product-recommendations');
    const currentRecsEl = document.querySelector('product-recommendations');
    if (!newRecsEl || !currentRecsEl) return;

    currentRecsEl.replaceWith(newRecsEl.cloneNode(true));

    const recsEl = document.querySelector('product-recommendations');
    if (!recsEl) return;

    const recsUrl = recsEl.dataset.url;
    if (!recsUrl) return;

    fetch(recsUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newInner = doc.querySelector('product-recommendations');
        if (newInner) {
          recsEl.innerHTML = newInner.innerHTML;

          const currentHandle = getCurrentHandle();
          const partnerHandle = SWATCH_PARTNERS[currentHandle];
          if (partnerHandle) {
            prependPartnerCard(recsEl, partnerHandle);
          }
        }
      })
      .catch(() => {
        // Recommendations swap failed silently — not critical
      });
  }

  // Swap runs in chunks with yields in between so the click can paint (fade-out)
  // straight away instead of waiting for the whole swap in one long task.
  async function doSwap(fetchedDoc, targetUrl) {
    await afterNextPaint();

    // Swap ProductJson so variant-gallery.js reads the correct product
    const newProductJson = fetchedDoc.getElementById('ProductJson');
    const currentProductJson = document.getElementById('ProductJson');
    if (newProductJson && currentProductJson) {
      currentProductJson.textContent = newProductJson.textContent;
    }

    // Replace entire media-gallery element to re-initialize thumbnail listeners
    reinitMediaGallery(fetchedDoc);
    swapZoomModal(fetchedDoc);

    // magnify.js binds click-to-zoom to images once on page load; re-bind for the
    // swapped-in gallery images (ratio 2 matches magnify.js's own call)
    if (typeof enableZoomOnHover === 'function') enableZoomOnHover(2);

    await yieldToMain();

    // Swap product info wrapper
    const newInfo = fetchedDoc.querySelector('.product__info-wrapper');
    const currentInfo = document.querySelector('.product__info-wrapper');
    if (newInfo && currentInfo) {
      currentInfo.replaceWith(newInfo);
    }

    // Update URL and title
    history.pushState({}, fetchedDoc.title, targetUrl);
    document.title = fetchedDoc.title;

    // Fade back in
    const updatedProductInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (updatedProductInfo) {
      updatedProductInfo.style.transition = 'opacity 0.1s ease';
      updatedProductInfo.style.opacity = '1';
    }

    // Clear used cache entry so revisiting re-fetches fresh content
    prefetchCache.delete(targetUrl);

    // Re-attach listeners on newly swapped content
    initSwatchAjax();

    await yieldToMain();

    // Swap recommendations section (below the fold)
    swapRecommendations(fetchedDoc);

    // Preload the new page's swatch targets
    preloadAllSwatchesWhenIdle();
  }

  function initSwatchAjax() {
    document.querySelectorAll('[data-swatch-ajax]').forEach((link) => {

      link.addEventListener('touchstart', function () {
        prefetch(this.href);
      }, { passive: true });

      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const targetUrl = this.href;
        const productInfo = document.querySelector('product-info[id^="MainProduct-"]');

        // Fade out
        productInfo.style.transition = 'opacity 0.1s ease';
        productInfo.style.opacity = '0.3';

        const cached = prefetchCache.get(targetUrl);
        const docPromise = (cached instanceof Document)
          ? Promise.resolve(cached)
          : fetch(targetUrl)
              .then((res) => res.text())
              .then((html) => {
                const parser = new DOMParser();
                return parser.parseFromString(html, 'text/html');
              });

        docPromise
          .then((fetchedDoc) => doSwap(fetchedDoc, targetUrl))
          .catch(() => {
            window.location.href = targetUrl;
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSwatchAjax();
    preloadAllSwatchesWhenIdle();
    clearCacheOnExit();
  });

})();
